/**
 * TD: Low-stock inventory indicator
 * Keeps the "Only X left in your size" message ([data-low-stock]) in sync when
 * the shopper switches variants, by listening to the theme's `tdVariantChange`
 * event (dispatched from utilities.js.liquid with the full variant object).
 * All copy comes from `data-text-*` attributes (translated in the snippet via
 * `| t`). The element is hidden via CSS when empty (`.td-low-stock:empty`).
 */
(function () {
  function updateEl(el, variant) {
    if (!variant) {
      el.textContent = '';
      return;
    }

    var threshold = parseInt(el.getAttribute('data-threshold'), 10);
    var qty = variant.inventory_quantity;
    var tracked = variant.inventory_management != null && variant.inventory_management !== '';

    if (tracked && qty > 0 && !isNaN(threshold) && qty <= threshold) {
      var prefix = el.getAttribute('data-text-prefix');
      var suffix = qty === 1 ? el.getAttribute('data-text-one') : el.getAttribute('data-text-other');
      var sizeText = el.getAttribute('data-text-size');
      el.textContent = prefix + ' ' + qty + ' ' + suffix + (sizeText ? ' ' + sizeText : '');
    } else {
      el.textContent = '';
    }
  }

  document.addEventListener('tdVariantChange', function (e) {
    var variant = e.detail && e.detail.variant;
    var els = document.querySelectorAll('[data-low-stock]');
    for (var i = 0; i < els.length; i++) {
      updateEl(els[i], variant);
    }
  });
})();
